import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import InputLabel from "@mui/material/InputLabel";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import visuallyHidden from "@mui/utils/visuallyHidden";
import { styled } from "@mui/material/styles";

const StyledBox = styled("div")(({ theme }) => ({
  alignSelf: "center",
  width: "100%",
  backgroundImage: `url(assets/header-girl.png)`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",

  [theme.breakpoints.up("sm")]: {
    height: 300,
    position: "relative",
    top: -49,
  },
  [theme.breakpoints.up("xs")]: {
    height: 386,
    backgroundSize: "contain",
  },
}));

export default function Hero() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        backgroundRepeat: "no-repeat",

        backgroundImage:
          "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage:
            "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)",
        }),
      })}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 14, sm: 20 },
          pb: { xs: 8, sm: 12 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexFlow: { xs: "column-reverse", sm: "row" },
          }}
        >
          {" "}
          <Stack
            spacing={2}
            useFlexGap
            sx={{ width: { xs: "100%", sm: "50%" } }}
          >
            <Typography
              variant="h1"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                fontSize: "clamp(3rem, 10vw, 3.5rem)",
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              Neyrolingvistik ilmiy-tadqiqot raqamli platformasi
            </Typography>
            <Typography
              sx={{
                textAlign: { xs: "center", sm: "left" },
                color: "text.secondary",
                width: { sm: "100%", md: "80%" },
              }}
            >
              Butun dunyoda neyrolingvistik tadqiqotlarni rivojlantirish
              bolalarning hissiy, aqliy va nutqiy rivojlanishini
              qo‘llab-quvvatlashga doir turli dasturlar hukumat va xalqaro
              ittifoqlar miqyosida ishlab chiqilmoqda.
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              useFlexGap
              sx={{
                pt: 2,
                width: { xs: "100%", sm: "350px" },
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                size="small"
                sx={{
                  minWidth: "fit-content",
                  width: { xs: "100%", sm: "200px" },
                  height: "47px",
                }}
                onClick={() => scrollToSection("highlights")}
              >
                Loyiha haqida
              </Button>
            </Stack>
          </Stack>
          <Stack sx={{ width: { xs: "100%", sm: "50%" } }}>
            {" "}
            <StyledBox id="image" />
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
